import React from 'react'
import {Button,Input,Col,Row } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalSearch = (props) => {

    const {modalSearch,toggleModalSearch,searchNim,handleInputChange,nim, cancelledMessage } = props;


    return (
        <Dialog 
            className="pt-0 medium-dialog"
            header="Búsqueda de orden de trabajo"
            visible={modalSearch}
            style={{ width: '60vw', maxWidth: '700px' }}
            modal
            contentClassName="pb-0"
            onHide={toggleModalSearch}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white'} },
                headerIcon: { style: { color: 'white' } },
                content: {style: {paddingLeft: "1px" } }
                }}
            footer={
                <Col sm="12">
                    <Button outline color='info' onClick={ () => searchNim() } > Buscar</Button>
                </Col>
            }
            >
                <>   
                    <Col sm="12">
                    <Row>
                        <Col sm="12" md="12" lg="12" className="text-center">
                        <img
                            className="img-fluid"
                            src={require("../../assets/images/recordatorio_cedimi.png")}
                            style={{ width: "130%" }}
                            alt="Recordatorio Cedimi"
                        />
                        <br />
                        </Col>
                        <Col sm="12" className='p-l-0 p-r-0 mt-2' >
                        <label className='' style={{color:"#0d3b59"}} >Ingresar Nim</label>
                        <Input 
                            type="text" 
                            name="paternal_surname" 
                            className="form-control form-control-sm input-air-primary"
                            value={nim} 
                            onChange={handleInputChange} 
                            />
                            <br />
                            {cancelledMessage && (
                            <div style={{
                                padding: '10px 20px', 
                                backgroundColor: '#f8d7da', 
                                color: '#721c24', 
                                borderRadius: '5px', 
                                border: '1px solid #f5c6cb', 
                                display: 'flex', 
                                alignItems: 'center',
                                fontWeight: 'bold',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                fontSize: '14px',
                                marginBottom: '15px',
                            }}>
                                <i className="fa fa-times-circle" style={{ marginRight: '10px', fontSize: '18px' }}></i>
                                <span>El NIM ha sido cancelado</span>
                            </div>
                            )}

                        </Col>
                        
                    </Row>       
                    </Col>
                   
                </>
        </Dialog>
    )
}
